<div class="flex flex-col">
  <span class="bg-(--header-bg) flex flex-col text-(--grey) p-4 gap-y-4 gap-x-1">
    @if (!isEditing()) {
    <div class="flex flex-row">
      <span class="text-lg font-semibold truncate">{{ participant()?.firstName }}</span>
      <span class="text-lg font-semibold truncate ml-1">{{ participant()?.lastName }}</span>
    </div>
    <span class="text-sm">{{ participant()?.email }}</span>
    <span class="text-sm">Unique ID #{{ participant()?.uniqueId }}</span>
    <span class="text-sm">Hogan ID #{{ participant()?.id }}</span>
    @if (permissions.canModify()) {
    <div class="flex gap-4">
      <button type="button" class="text-(--edit-color) font-semibold text-sm text-left" (click)="startEdit()">
        edit
      </button>
      <button type="button" class="text-(--edit-color) font-semibold text-sm text-left" [disabled]="resendingInvite()"
        (click)="resendInvite()">
        resend invite
      </button>
    </div>
    }
    }
    @else {
    <div class="flex flex-col gap-1">
      <input class="text-lg font-semibold truncate bg-transparent border-b outline-none"
        [ngClass]="firstNameInvalid() ? 'border-(--red)' : 'border-(--edit-color)'" [ngModel]="editFirstName()"
        (ngModelChange)="editFirstName.set($event)" placeholder="First name" />
      <input class="text-lg font-semibold truncate bg-transparent border-b outline-none"
        [ngClass]="lastNameInvalid() ? 'border-(--red)' : 'border-(--edit-color)'" [ngModel]="editLastName()"
        (ngModelChange)="editLastName.set($event)" placeholder="Last name" />
    </div>
    <span class="text-sm">
      <input class="w-full bg-transparent border-b outline-none text-sm border-(--edit-color)" [ngModel]="editEmail()"
        (ngModelChange)="editEmail.set($event)" placeholder="Email" />
    </span>
    <span class="text-sm">
      <span class="mr-1">Unique ID #</span>
      <input class="bg-transparent border-b border-(--edit-color) outline-none text-sm max-w-[150px]"
        [ngModel]="editUniqueId()" (ngModelChange)="editUniqueId.set($event)" placeholder="Unique ID" />
    </span>
    <span class="text-sm">Hogan ID #{{ participant()?.id }}</span>

    @if (firstNameInvalid()) {
    <span class="text-(--red) text-xs font-semibold">First name is required</span>
    }
    @if (lastNameInvalid()) {
    <span class="text-(--red) text-xs font-semibold">Last name is required</span>
    }
    @if (emailInvalid()) {
    <span class="text-(--red) text-xs font-semibold">Email is required</span>
    }
    <span class="text-sm flex gap-2 justify-start">
      <button type="button" class="font-semibold text-sm" [disabled]="participantSaving() || formInvalid()"
        (click)="saveEdit()" [ngClass]="participantSaving() || formInvalid() ? 'text-(--grey)' : 'text-(--edit-color)'">
        save
      </button>
      <button type="button" class="text-(--edit-color) font-semibold text-sm" [disabled]="participantSaving()"
        (click)="cancelEdit()">
        cancel
      </button>
    </span>
    }
  </span>
  <span class="bg-(--grey) p-4 text-(--text-color) flex flex-col">
    <span class="text-base font-semibold">Reports</span>
    <span class="flex flex-col mb-4">
      @for(report of reportsForDisplay(); track report.id;) {
      <div class="flex flex-row items-center space-x-2 py-1 border-b-1 border-y-(--header-bg) border-y-solid"
        [class.border-t-1]="$first">
        <img src="assets/images/reports/{{ report.id }}.png" class="w-[30px]"
          appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async" alt="{{ report.name }}" />
        <span class="truncate grow">{{ report.name }}</span>
        @let status = getReportStatus(report.id);

        @switch (status) {
        @case (0) {
        @if (permissions.canModify()) {
        <button type="button" [disabled]="downloading()" (click)="regenerate(report.id)" i18n-matTooltip
          matTooltip="Rescore Report">
          <mat-icon fontSet="material-symbols-outlined"
            class="text-(--text-color)! text-[20px]! flex-none">cycle</mat-icon>
        </button>
        }
        <button type="button" [disabled]="downloading()" (click)="download(report, false)" i18n-matTooltip
          matTooltip="Download Report">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">download_2</mat-icon>
        </button>
        @if (permissions.canModify()) {
        <a [routerLink]="['reports', report.id ]" [relativeTo]="this.route" i18n-matTooltip
          matTooltip="View Report Options">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">settings</mat-icon>
        </a>
        }
        }
        @case (1) {
        <mat-icon fontSet="material-symbols-outlined" i18n-matTooltip matTooltip="Rescore in Progress"
          class="text-(--text-color)! text-[20px]! flex-none">hourglass_top</mat-icon>
        }
        @case (2) {
        @if (permissions.canModify()) {
        <a [routerLink]="['reports', report.id ]" [relativeTo]="this.route" i18n-matTooltip
          matTooltip="View Report Options">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">settings</mat-icon>
        </a>
        }
        }
        @default {
        @if (permissions.canModify()) {
        <button type="button" [disabled]="downloading()" (click)="regenerate(report.id)" i18n-matTooltip
          matTooltip="Rescore Report">
          <mat-icon fontSet="material-symbols-outlined"
            class="text-(--text-color)! text-[20px]! flex-none">cycle</mat-icon>
        </button>
        }
        <button type="button" [disabled]="downloading()" (click)="download(report, false)" i18n-matTooltip
          matTooltip="Download Report">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">download_2</mat-icon>
        </button>
        @if (permissions.canModify()) {
        <a [routerLink]="['reports', report.id ]" [relativeTo]="this.route" i18n-matTooltip
          matTooltip="View Report Options">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">settings</mat-icon>
        </a>
        }
        }
        }
      </div>
      }

      @for(pkg of packagesForDisplay(); track pkg.id;) {
      <div class="flex flex-row items-center space-x-2 py-1 border-b-1 border-y-(--header-bg) border-y-solid">
        <img src="assets/images/reports/Package.png" class="w-[30px]"
          appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async" alt="{{ pkg.name }}" />
        <span class="truncate grow">{{ pkg.name }}</span>
        @let status = getReportStatus(pkg.id);

        @switch (status) {
        @case (0) {
        @if (permissions.canModify()) {
        <button type="button" [disabled]="downloading()" (click)="regenerate(pkg.id)" i18n-matTooltip
          matTooltip="Rescore Report">
          <mat-icon fontSet="material-symbols-outlined"
            class="text-(--text-color)! text-[20px]! flex-none">cycle</mat-icon>
        </button>
        }
        <button type="button" [disabled]="downloading()" (click)="download(pkg, true)" i18n-matTooltip
          matTooltip="Download Report">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">download_2</mat-icon>
        </button>
        @if (permissions.canModify()) {
        <a [routerLink]="['reports', pkg.id ]" [relativeTo]="this.route" i18n-matTooltip
          matTooltip="View Report Options">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">settings</mat-icon>
        </a>
        }
        }
        @case (1) {
        <mat-icon fontSet="material-symbols-outlined" i18n-matTooltip matTooltip="Rescore in Progress"
          class="text-(--text-color)! text-[20px]! flex-none">hourglass_top</mat-icon>
        }
        @case (2) {
        @if (permissions.canModify()) {
        <a [routerLink]="['reports', pkg.id ]" [relativeTo]="this.route" i18n-matTooltip
          matTooltip="View Report Options">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">settings</mat-icon>
        </a>
        }
        }
        @default {
        @if (permissions.canModify()) {
        <a [routerLink]="['reports', pkg.id ]" [relativeTo]="this.route" i18n-matTooltip
          matTooltip="View Report Options">
          <mat-icon class="text-(--text-color)! text-[20px]! flex-none">settings</mat-icon>
        </a>
        }
        }
        }
      </div>
      }
      @if (permissions.canModify()) {
      <a matButton="filled" class="size-fit w-full mt-2! bg-(--brand-button-primary-fill)! self-center text-(--grey)!"
        i18n-aria-label aria-label="edit reports" [routerLink]="['reports']" [relativeTo]="this.route">
        Add Reports
      </a>
      }
    </span>

    <span class="flex flex-row justify-between items-center">
      <span class="text-base font-semibold">Assessments</span>
      <span class="text-base font-semibold">Status</span>
    </span>
    <span class="flex flex-col">
      @for(assessment of participantAssessments(); track assessment.id;) {
      <div class="flex flex-row items-center space-x-2 py-1 border-b-1 border-y-(--header-bg) border-y-solid"
        [class.border-t-1]="$first">
        <img src="assets/images/reports/{{ assessment.id }}.png" class="w-[30px]"
          appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async"
          alt="{{ assessment.id }}" />
        <span class="truncate grow">{{ assessment.id }}</span>
        @if(assessment.completedDate)
        {
        <span class="">{{ assessment.completedDate | date }}</span>
        }@else {
        <span class="">Pending</span>
        }
      </div>
      }
    </span>
  </span>
</div>
<router-outlet></router-outlet>